<template>
  <div class="grey-darken">
    <div class="empty-layout">
      <router-view />
      <ErrorDialog
        :error="store.getters.error"
        @clearError="store.commit('CLEAR_ERROR')"
      />
      <Toast :baseZIndex="999" />
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';

const store = useStore();
</script>
